const BiscuitsBundleCustomisation = (function() {
  const selectors = {
    card: '.biscuits-bundle-item-card',
    variantEl: 'biscuits-bundle-product, biscuits-bundle-variant',
    checkbox: '.biscuits-bundle-item-checkbox',
    title: '.biscuits-bundle-item__product-title',
    image: '.biscuits-bundle-item-image, .biscuits-bundle-product-image.active',
    richtext: '.biscuits-bundle-item__rich-text-metafield',
    json: '.biscuits-bundle-item__json',
  };

  const attributes = {
    step: 'data-biscuits-step',
    available: 'data-biscuits-available',
    handle: 'data-biscuits-handle',
    selectedVariantId: 'data-biscuits-selected-variant-id',
  };

  function BiscuitsBundleCustomisation() {
    this.biscuitsForm = document.querySelector('biscuits-bundle-form');
    if (!this.biscuitsForm) {
      return;
    }
    this.initPerStep();
  }

  BiscuitsBundleCustomisation.prototype = {
    initPerStep: function() {
      const steps = Array.from(document.querySelectorAll('.biscuits-bundle-step[data-biscuits-step]'));
      if (steps.length === 0) {
        console.error('[biscuits]', 'Master card init: no steps found');
        return;
      }
      this.instances = steps.map((stepElement) => {
        try {
          return new StepMasterCard(stepElement);
        } catch (e) {
          const stepNum = stepElement.getAttribute('data-biscuits-step') || '?';
          console.error('[biscuits]', 'Master card init failed for step', stepNum, e);
          return null;
        }
      });
    }
  };


  function StepMasterCard(stepElement) {
    this.stepElement = stepElement;

    this.bindElements();

    this.options = this.collectOptionsFromCards(this.cards);
    if (this.options.length === 0) {
      const stepNum = this.stepElement.getAttribute('data-biscuits-step') || '?';
      const totalCards = this.cards ? this.cards.length : 0;
      console.error('[biscuits]', 'Master card init skipped: no selectable options found', { step: stepNum, totalCards: totalCards });
      return;
    }

    this.buildElements();
   
    if (this.sliderContainer && this.sliderContainer.parentNode) {
      this.sliderContainer.parentNode.insertBefore(this.masterCardElement, this.sliderContainer);
    } else if (this.stepElement.firstChild) {
      this.stepElement.insertBefore(this.masterCardElement, this.stepElement.firstChild);
    } else {
      this.stepElement.appendChild(this.masterCardElement);
    }

    this.hideOriginalProductsList();
    this.bindEvents();
    this.updateMasterCardUI(this.selectedOption);

    this.onPageLoad();
  }


  StepMasterCard.prototype = {

    buildAnElement: function(tag, className, attrs) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (attrs) for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, v);
      return node;
    },

    bindElements: function() {
      this.productsWrapper = this.stepElement.querySelector('.biscuits-bundle-step__products');
      this.sliderContainer = this.stepElement.querySelector('.biscuits-bundle-step__slider-container');
      this.cards = Array.from(this.stepElement.querySelectorAll(`${selectors.card}[${attributes.available}]`));
    },

    parseCardToOption: function(card) {
      const variant = card.querySelector(selectors.variantEl);
      const checkbox = card.querySelector(selectors.checkbox);
      const titleNode = card.querySelector(selectors.title);
      const imageNode = card.querySelector(selectors.image);
      if (!variant || !titleNode || !imageNode) return null;

      const jsonNode = card.querySelector(selectors.json);
      let productUrl = '';
      if (jsonNode?.textContent) {
        try {
          const data = JSON.parse(jsonNode.textContent);
          if (data?.url) productUrl = data.url;
        } catch {}
      }

      const richtextNode = card.querySelector(selectors.richtext);
      const available = card.getAttribute(attributes.available) === 'true';
      const preselected = card.classList.contains('biscuits-bundle-item-card--preselected')
        || !!card.querySelector('[data-biscuits-preselected]')
        || !!checkbox?.checked;

      return {
        variantId: variant.getAttribute(attributes.selectedVariantId) || '',
        title: titleNode.textContent?.trim() || '',
        imageSrc: imageNode.getAttribute('src') || '',
        imageAlt: imageNode.getAttribute('alt') || '',
        richtextHtml: richtextNode ? richtextNode.innerHTML : '',
        productHandle: variant.getAttribute(attributes.handle) || '',
        productUrl,
        available,
        cardElement: card,
        checkboxElement: checkbox || null,
        preselected,
      };
    },

    pickInitialOption: function(options) {
      return (
        options.find(o => o?.preselected && o.available !== false)
        || options.find(o => o?.checkboxElement?.checked && o.available !== false)
        || options.find(o => o?.available !== false)
        || options[0]
      );
    },

    setSummary: function(summaryImg, summaryLabel, option) {
      if (summaryImg) {
        if (option.imageSrc) summaryImg.src = option.imageSrc;
        if (option.imageAlt) summaryImg.alt = option.imageAlt;
      }
      if (summaryLabel) summaryLabel.textContent = option.title || '';
    },

    setLearnMore: function(btn, option) {
      if (!btn) return;
      if (option.productHandle) {
        btn.setAttribute('data-biscuits-handle', `${option.productHandle}?view=bundle-modal`);
        btn.classList.remove('biscuits--hidden');
      } else {
        btn.removeAttribute('data-biscuits-handle');
        btn.classList.add('biscuits--hidden');
      }
    },

    setMasterCardUI: function(master, option) {
      const { imageEl, titleEl, richtextEl } = master;
      console.log(master, option.checkboxElement.id, "data")
      if (!imageEl) return;

      if (option.imageSrc) imageEl.src = option.imageSrc;
      if (option.imageAlt) imageEl.alt = option.imageAlt;

      // Extract position and productId using regex
      const match = option.checkboxElement.id.match(/biscuits-product-checkbox-(\d+)-(\d+)/);
      if (!match) return;
      const [, position, productId] = match;
      console.log(position, productId, "position and id");

      const bundleProductImage = document.querySelector('.bundle-product-image');
      const bundleProductImageContent = bundleProductImage?.closest('.image-block');
      const bundleFlatlayImageContent = document.querySelector('.biscuits-bundle-custom-details-wrapper');

      if (!bundleProductImage || !bundleProductImageContent) return;

      // Find flatlay image wrapper for this product ID
      const flatlayImageWrapper = Array.from(
        bundleFlatlayImageContent?.querySelectorAll('.biscuits-bundle-custom-details') || []
      ).find(el => el.dataset.biscuitsProductId == productId);

      // Create a new image element
      const img = document.createElement('img');
      img.classList.add('biscuits-img', `biscuits-img__${productId}`, `biscuits-img-position__${position}`);

      // Find existing image for this product ID
      const oldProductImage = Array.from(
        bundleProductImageContent.querySelectorAll('.biscuits-img') || []
      ).find(el => el.classList.contains(`biscuits-img__${productId}`));

      // Hide all images for this position
      bundleProductImageContent
        .querySelectorAll(`.biscuits-img-position__${position}`)
        .forEach(el => el.classList.add('biscuits--hidden'));

      if (!oldProductImage && flatlayImageWrapper) {
        const flatlayImg = flatlayImageWrapper.querySelector('img');
        if (flatlayImg) {
          img.src = flatlayImg.src;
          img.srcset = flatlayImg.src;
          img.alt = flatlayImg.alt || option.imageAlt || '';
        }

        bundleProductImageContent.appendChild(img);
      }

      // Show the selected image
      bundleProductImageContent
        .querySelector(`.biscuits-img__${productId}`)
        ?.classList.remove('biscuits--hidden');

      if (titleEl) titleEl.textContent = option.title || '';
      if (richtextEl) {
        if (option.richtextHtml?.trim()) {
          richtextEl.innerHTML = option.richtextHtml;
          richtextEl.classList.remove('biscuits--hidden');
        } else {
          richtextEl.innerHTML = '';
          richtextEl.classList.add('biscuits--hidden');
        }
      }
    },

    setDropdownAria: function(menuEl, selectedVariantId) {
      Array.from(menuEl.querySelectorAll('.bb-master-dropdown__option')).forEach(item => {
        const id = item.getAttribute('data-variant-id');
        item.setAttribute('aria-selected', id === selectedVariantId ? 'true' : 'false');
      });
    },
  
    buildDropdownOption: function(option) {
      const item = this.buildAnElement('li', 'bb-master-dropdown__option', { 'role': 'option', 'data-variant-id': option.variantId });
      const btn = this.buildAnElement('button', 'bb-master-dropdown__button', { 'type': 'button', 'data-variant-id': option.variantId });
      if (option.available === false) {
        btn.disabled = true;
        item.setAttribute('aria-disabled', 'true');
      }
      const thumb = this.buildAnElement('img', 'bb-master-dropdown__option-thumb');
      thumb.src = option.imageSrc;
      if (option.imageAlt) thumb.alt = option.imageAlt;
      const label = this.buildAnElement('span', 'bb-master-dropdown__option-label');
      label.textContent = option.title;
      btn.append(thumb, label);
      item.append(btn);
      return item;
    },

    fetchMainContent: async function(url) {
      const res = await fetch(url, { credentials: 'same-origin' });
      const html = await res.text();
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const main = doc.querySelector('#MainContent');
        return main ? main.innerHTML : html;
      } catch {
        return html;
      }
    },

    buildElements: function() {
      this.selectedOption = this.pickInitialOption(this.options);
      this.masterCardElement = this.buildMasterCard();
    },

    collectOptionsFromCards: function(cards) {
      const options = [];
      for (const card of cards) {
        const option = this.parseCardToOption(card);
        if (option) options.push(option);
      }
      return options;
    },
    
    onPageLoad: function() {
      if (!this.selectedOption) {
        return;
      }
      this.selectOption(this.selectedOption, { closeDropdown: false, syncCheckbox: true });
    },

    bindEvents: function() {
      this.dropdownMenu.addEventListener('click', (event) => {
        const button = event.target.closest('.bb-master-dropdown__button');
        if (!button) {
          return;
        }
        const variantId = button.getAttribute('data-variant-id');
        const option = this.options.find((o) => o.variantId === variantId);
        if (!option) {
          return;
        }
        this.selectOption(option, { closeDropdown: true, syncCheckbox: true });
      });
  
      this.stepElement.addEventListener('change', (event) => {
        const input = event.target;
        if (!input || !input.classList || !input.classList.contains('biscuits-bundle-item-checkbox')) {
          return;
        }
        const card = input.closest('.biscuits-bundle-item-card');
        if (!card) {
          return;
        }
        const variantElement = card.querySelector('biscuits-bundle-variant');
        if (!variantElement) {
          return;
        }
        const variantId = variantElement.getAttribute('data-biscuits-id') || '';
        const option = this.options.find((o) => o.variantId === variantId);
        if (!option) {
          return;
        }
        if (input.checked) {
          this.selectOption(option, { closeDropdown: false, syncCheckbox: false });
        }
      });
  
      this.dropdownElement.addEventListener('toggle', () => {
        const expanded = this.dropdownElement.hasAttribute('open');
        const summary = this.dropdownElement.querySelector('.bb-master-dropdown__summary');
        if (summary) {
          summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      })

      document.addEventListener('click', (evt) => {
        if (!this.dropdownElement) {
          return;
        }
        const isOpen = this.dropdownElement.hasAttribute('open');
        const clickedInside = this.dropdownElement.contains(evt.target);
        if (isOpen && !clickedInside) {
          this.dropdownElement.removeAttribute('open');
          const summary = this.dropdownElement.querySelector('.bb-master-dropdown__summary');
          if (summary) {
            summary.setAttribute('aria-expanded', 'false');
          }
        }
      });

      if (this.masterLearnMoreElement) {
        this.masterLearnMoreElement.addEventListener('click', (event) => {
          event.preventDefault();
          const handleAttr = this.masterLearnMoreElement.getAttribute('data-biscuits-handle') || '';
          if (!handleAttr) {
            return;
          }
          let url = handleAttr;
          if (!/^https?:\/\//.test(url) && url.charAt(0) !== '/') {
            url = '/products/' + url;
          }
          this.openLearnMoreModal(url);
        });
      }
    },

    buildMasterCard: function() {
      const container = this.buildAnElement('div', 'bb-master-card');
      const image = this.buildAnElement('img', 'bb-master-card__image', { loading: 'lazy' });
      const detailsContainer = this.buildAnElement('div', 'bb-master-card__details');
      const title = this.buildAnElement('div', 'bb-master-card__title');
      const richtext = this.buildAnElement('div', 'bb-master-card__richtext');
      const learnMore = this.buildAnElement('button', 'bb-master-card__learn-more', { type: 'button' });
      learnMore.textContent = 'Learn more';
      const dropdown = this.buildDropdown();

      container.append(image, detailsContainer, dropdown);
      detailsContainer.append(title, richtext, learnMore);

      this.masterImageElement = image;
      this.masterTitleElement = title;
      this.masterRichtextElement = richtext;
      this.masterLearnMoreElement = learnMore;
      this.dropdownElement = dropdown;
      this.dropdownSummaryImage = dropdown.querySelector('.bb-master-dropdown__thumb');
      this.dropdownSummaryLabel = dropdown.querySelector('.bb-master-dropdown__label');
      this.dropdownMenu = dropdown.querySelector('.bb-master-dropdown__menu');

      return container;
    },

    buildDropdown: function() {
      const details = this.buildAnElement('details', 'bb-master-dropdown');
      const summary = this.buildAnElement('summary', 'bb-master-dropdown__summary', { 'aria-haspopup': 'listbox', 'aria-expanded': 'false' });
      const summaryThumb = this.buildAnElement('img', 'bb-master-dropdown__thumb', { loading: 'lazy' });
      const summaryLabel = this.buildAnElement('span', 'bb-master-dropdown__label');
      const menu = this.buildAnElement('ul', 'bb-master-dropdown__menu', { role: 'listbox' });

      summary.append(summaryThumb, summaryLabel);
      this.options.forEach(option => menu.append(this.buildDropdownOption(option)));
      details.append(summary, menu);
      return details;
    },

    openLearnMoreModal: async function(url) {
      this.ensureLearnMoreModal();
      if (!this.learnMoreContent) return;
      
      this.learnMoreContent.innerHTML = '<div style="padding:16px">Loading…</div>';
      try {
        this.learnMoreContent.innerHTML = await this.fetchMainContent(url);
      } catch {
        this.learnMoreContent.innerHTML = '<div style="padding:16px">Unable to load content.</div>';
      }
      this.learnMoreOverlay.classList.remove('biscuits--hidden');
      document.addEventListener('keydown', this.onLearnMoreKeydown);
    },

    ensureLearnMoreModal: function() {
      if (this.learnMoreOverlay) {
        return;
      }
      this.onLearnMoreKeydown = (evt) => {
        if (evt.key === 'Escape') {
          this.closeLearnMoreModal();
        }
      };
      const overlay = this.buildAnElement('div', 'bb-learn-more-overlay biscuits--hidden', { role: 'dialog', 'aria-modal': 'true' });
      const container = this.buildAnElement('div', 'bb-learn-more-container');
      const closeBtn = this.buildAnElement('button', 'bb-learn-more-close', { type: 'button', 'aria-label': 'Close' });
      closeBtn.textContent = '×';
      closeBtn.addEventListener('click', () => this.closeLearnMoreModal());
      const content = this.buildAnElement('div', 'bb-learn-more-content');
  
      overlay.addEventListener('click', (evt) => {
        if (evt.target === overlay) {
          this.closeLearnMoreModal();
        }
      });

      container.append(closeBtn, content);
      overlay.append(container);
      document.body.append(overlay);
  
      this.learnMoreOverlay = overlay;
      this.learnMoreContent = content;
    },

    closeLearnMoreModal: function() {
      if (this.learnMoreOverlay) {
        this.learnMoreOverlay.classList.add('biscuits--hidden');
      }
      document.removeEventListener('keydown', this.onLearnMoreKeydown);
    },

    hideOriginalProductsList: function() {
      if (this.productsWrapper) {
        this.productsWrapper.classList.add('biscuits--hidden');
      }
    },

    updateMasterCardUI: function(option) {
      if (!option) return;
      
      this.setMasterCardUI({
        imageEl: this.masterImageElement,
        titleEl: this.masterTitleElement,
        richtextEl: this.masterRichtextElement
      }, option);
      
      this.setSummary(this.dropdownSummaryImage, this.dropdownSummaryLabel, option);
      this.setLearnMore(this.masterLearnMoreElement, option);
      this.setDropdownAria(this.dropdownMenu, option.variantId);
    },

    selectOption: function(option, { closeDropdown, syncCheckbox }) {
      this.selectedOption = option;
      this.updateMasterCardUI(option);

      // Unselect all other options in this step
      for (const other of this.options) {
        if (!other || other === option) continue;
        const cb = other.checkboxElement;
        if (cb?.checked && !cb.disabled) cb.click();
      }
      if (syncCheckbox && option.checkboxElement && !option.checkboxElement.checked && !option.checkboxElement.disabled) {
        option.checkboxElement.click();
      }
      if (closeDropdown && this.dropdownElement && this.dropdownElement.open) {
        this.dropdownElement.open = false;
      }

      // Set total price
      const totalPriceEl = document.querySelector('.biscuits-bundle-form__total');
      if (!totalPriceEl) return;

      const section = totalPriceEl.closest('.shopify-section');
      const targetTextEl = section?.querySelector('.add-to-cart-text__content');

      const totalPrice = totalPriceEl.textContent?.trim();
      if (targetTextEl && totalPrice) {
        targetTextEl.textContent = `add • ${totalPrice}`;
      }
    }

  }

  return BiscuitsBundleCustomisation;
})();
  
document.addEventListener('BiscuitsBundleForm:ready', () => {
  window.BiscuitsBundleCustomisation = new BiscuitsBundleCustomisation();
});